(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-status', {
            parent: 'entity',
            url: '/qsched-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-status/qsched-statuses.html',
                    controller: 'Qsched_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-status-detail', {
            parent: 'entity',
            url: '/qsched-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-status/qsched-status-detail.html',
                    controller: 'Qsched_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_status', function($stateParams, Qsched_status) {
                    return Qsched_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-status-detail.edit', {
            parent: 'qsched-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-status.new', {
            parent: 'qsched-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('qsched-status');
                });
            }]
        })
        .state('qsched-status.edit', {
            parent: 'qsched-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-dialog.html',
                    controller: 'Qsched_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-status.delete', {
            parent: 'qsched-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-status/qsched-status-delete-dialog.html',
                    controller: 'Qsched_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_status', function(Qsched_status) {
                            return Qsched_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-status', null, { reload: 'qsched-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
